export default __webpack_public_path__ + "static/proximanova-regular-woff-e7aae5a7dc222de7f53243383b5c8111.woff";